export const XR_SCENE_FADE_MS = 250;
/** Frames a new scene gets to place the viewer before the fade lifts. */
export const XR_SCENE_SETTLE_FRAMES = 2;
const MAX_FADE_STEP_SECONDS = 1 / 30;
export function initialXrSceneFade(owner) {
    return owner === undefined
        ? { owner, settledFrames: 0, opacity: 1 }
        : { owner, settledFrames: XR_SCENE_SETTLE_FRAMES, opacity: 0 };
}
/** Blacks out at once when the scene goes or changes, then fades in once the new scene has settled. */
export function stepXrSceneFade(state, owner, deltaSeconds, fadeMs = XR_SCENE_FADE_MS) {
    if (owner === undefined || owner !== state.owner)
        return { owner, settledFrames: 0, opacity: 1 };
    if (state.settledFrames < XR_SCENE_SETTLE_FRAMES)
        return { ...state, settledFrames: state.settledFrames + 1 };
    if (state.opacity === 0)
        return state;
    const step = Math.min(Math.max(deltaSeconds, 0), MAX_FADE_STEP_SECONDS) * 1000 / fadeMs;
    const opacity = state.opacity - step;
    return { ...state, opacity: opacity > 1e-6 ? opacity : 0 };
}
